      window.addEventListener('pplrAppInitiated', function(e) {
          // check if pplr has loaded
          if (typeof pplrcomplete === "function") {
              var originalPplrcomplete = pplrcomplete;
              pplrcomplete = function(...args) {
                  //console.log("pplrcomplete detected:", args);

                  // Write the codes below
                  document.querySelectorAll('.pplrlabel').forEach(function(label) {
                      label.removeAttribute('data-seq'); // Remove old sequence number
                  });

                  // Select all elements with the class "pplrlabel"
                  var labels = document.querySelectorAll('.pplrlabel');
                  var counter = 1; // Start the sequence from 1

                  labels.forEach(function(label) {
                      // Check if the label has a parent with class "pplr_no_preview"
                      if (label.closest('.pplr_no_preview')) {
                          return; // Skip this label
                      }

                      // Assign the sequence number as a data attribute
                      label.setAttribute('data-seq', counter);
                      counter++; // Increment counter
                  });

                  return originalPplrcomplete.apply(this, args);
              };
          }

      })